@if (levels().length > 0) {
  @for (level of levels(); track levelIndex; let levelIndex = $index) {
    <section>
      <!-- Input search -->
      <div
        [style.background-color]="getColor(levelIndex)"
        class="flex justify-between items-baseline p-2"
      >
        <div class="inline-block text-lg font-medium mb-0 ml-4">
          {{ levelIndex === 0 ? title : getParentNode(levelIndex)?.name }}
        </div>

        @if (searchBar) {
          <div class="inline-block mr-3">
            <siat-search-node
              [levelData]="level"
              [levelIndex]="levelIndex"
              (onSelectEventEmitter)="searchAndSelectNode($event, levelIndex)"
            ></siat-search-node>
          </div>
        }
      </div>
      <!-- end of input search-->
      <!-- Carousel -->
      <siat-carousel
        [items]="level"
        [carouselId]="levelIndex"
        [backgroundColor]="getColor(levelIndex)"
        [expandedIndex]="getExpandedIndex(level)"
        #carousel
      >
        <ng-template let-item>
          <siat-node-item
            class="grid auto-cols-auto"
            [node]="item"
            [arrowColor]="getColor(levelIndex, true)"
            (toggleEvent)="toggleNode(item, levelIndex)"
            (onClickUpdateNodeEventEmitter)="
              onClickUpdateNodeEventEmitter.emit(item)
            "
            (onClickDeleteNodeEventEmitter)="
              onClickDeleteNodeEventEmitter.emit(item)
            "
          >
          </siat-node-item>
        </ng-template>
        <ng-template #extraItem>
          <siat-node-item
            class="grid auto-cols-auto"
            (addNodeClick)="onClickAddNode(levelIndex)"
          >
          </siat-node-item>
        </ng-template>
      </siat-carousel>
    </section>
    <!-- end of carousel -->
  }
}
